import { DealFooter } from './DealFooter'

export default DealFooter
